import { gql } from '@apollo/client';

export const shiftAppsByUser = gql/* GraphQL */ `query ShiftAppsByUser(
  $filter: ModelAgendaShiftApplicationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
  $userId: ID!
) {
  shiftAppsByUser(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
    userId: $userId
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
      user {
        username
        type
        image
      }
    }
    nextToken
    __typename
  }
}
`;

export const getAgendaShiftApplication = gql/* GraphQL */ `query GetAgendaShiftApplication($shiftAppId: ID!) {
  getAgendaShiftApplication(shiftAppId: $shiftAppId) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    info
    location
    role
    shiftAppId
    shifts {
      nextToken
      __typename
    }
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const shiftAppsByComId = gql/* GraphQL */ `query ShiftAppsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftApplicationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftAppsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const shiftsByUser = gql/* GraphQL */ `query ShiftsByUser(
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
  $userId: ID!
) {
  shiftsByUser(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
    userId: $userId
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const onCreateAgendaShiftApplicationByUserId = gql/* GraphQL */ `subscription OnCreateAgendaShiftApplicationByUserId($userId: ID) {
  onCreateAgendaShiftApplicationByUserId(userId: $userId) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    info
    location
    role
    shiftAppId
    shifts {
      nextToken
      __typename
    }
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const createAgendaShiftApplicationByUserId = gql/* GraphQL */ `mutation CreateAgendaShiftApplicationByUserId(
  $accepted: Boolean
  $comId: ID
  $confirmed: Boolean
  $createdAt: AWSDateTime
  $deleted: Boolean
  $info: String
  $location: String
  $role: String
  $shiftAppId: ID!
  $startAt: AWSDateTime
  $stopAt: AWSDateTime
  $suspended: Boolean
  $updatedAt: AWSDateTime
  $userId: ID
  $username: String
  $lat: String
  $lng: String
) {
  createAgendaShiftApplicationByUserId(
    accepted: $accepted
    comId: $comId
    confirmed: $confirmed
    createdAt: $createdAt
    deleted: $deleted
    info: $info
    location: $location
    role: $role
    shiftAppId: $shiftAppId
    startAt: $startAt
    stopAt: $stopAt
    suspended: $suspended
    updatedAt: $updatedAt
    userId: $userId
    username: $username
    lat: $lat
    lng: $lng
  ) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    info
    location
    role
    shiftAppId
    shifts {
      nextToken
      __typename
    }
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

// export const onCreateAgendaShiftByUserId = gql/* GraphQL */ `
// subscription OnCreateAgendaShiftByUserId {
//   onCreateAgendaShiftByUserId {
//     accepted
//     comId
//     confirmed
//     createdAt
//     deleted
//     info
//     location
//     role
//     shiftId
//     startAt
//     stopAt
//     suspended
//     updatedAt
//     userId
//     username
//     __typename
//   }
// }
// `;

// export const createAgendaShiftByUserId = gql/* GraphQL */ `mutation CreateAgendaShiftByUserId(
//   $accepted: Boolean
//   $comId: ID
//   $confirmed: Boolean
//   $createdAt: AWSDateTime
//   $deleted: Boolean
//   $info: String
//   $location: String
//   $performance: String
//   $punctuality: String
//   $quality: String
//   $rate: String
//   $role: String
//   $shiftId: ID!
//   $startAt: AWSDateTime
//   $stopAt: AWSDateTime
//   $suspended: Boolean
//   $updatedAt: AWSDateTime
//   $userId: ID
//   $username: String
// ) {
//   createAgendaShiftByUserId(
//     accepted: $accepted
//     comId: $comId
//     confirmed: $confirmed
//     createdAt: $createdAt
//     deleted: $deleted
//     info: $info
//     location: $location
//     performance: $performance
//     punctuality: $punctuality
//     quality: $quality
//     rate: $rate
//     role: $role
//     shiftId: $shiftId
//     startAt: $startAt
//     stopAt: $stopAt
//     suspended: $suspended
//     updatedAt: $updatedAt
//     userId: $userId
//     username: $username
//   ) {
//     accepted
//     comId
//     confirmed
//     createdAt
//     deleted
//     info
//     location
//     performance
//     punch {
//       nextToken
//       __typename
//     }
//     punctuality
//     quality
//     rate
//     requests {
//       nextToken
//       __typename
//     }
//     role
//     shiftApps {
//       nextToken
//       __typename
//     }
//     shiftId
//     startAt
//     stopAt
//     suspended
//     updatedAt
//     user {
//       FCMtoken
//       comId
//       createdAt
//       email
//       firstName
//       friday
//       hours
//       image
//       isConfirmed
//       language
//       lastName
//       monday
//       night
//       password
//       phoneNumber
//       profileOwner
//       readedAt
//       role
//       saturday
//       sunday
//       suspended
//       thursday
//       timezone
//       tuesday
//       type
//       updatedAt
//       userId
//       username
//       wednesday
//       __typename
//     }
//     userId
//     username
//     __typename
//   }
// }
// `

export const getAgendaUser = gql/* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      email
      image
      language
      isConfirmed
      role
      suspended
      type
      FCMtoken
      userId
      username
      monday
      tuesday
      thursday
      wednesday
      friday
      saturday
      sunday
      night
      hours
      readedAt
      __typename
    }
  }
  `;

// export const listAgendaUsers = gql/* GraphQL */ `
// query ListAgendaUsers(
//   $filter: ModelAgendaUserFilterInput
//   $limit: Int
//   $nextToken: String
//   $sortDirection: ModelSortDirection
//   $userId: ID
// ) {
//   listAgendaUsers(
//     filter: $filter
//     limit: $limit
//     nextToken: $nextToken
//     sortDirection: $sortDirection
//     userId: $userId
//   ) {
//     items {
//       comId
//       createdAt
//       email
//       firstName
//       image
//       isConfirmed
//       language
//       lastName
//       password
//       phoneNumber
//       profileOwner
//       readedAt
//       role
//       suspended
//       type
//       FCMtoken
//       updatedAt
//       userId
//       username
//       __typename
//     }
//     nextToken
//     __typename
//   }
// }
// `;
export const usersByComId = gql/* GraphQL */ `
query UsersByComId(
  $comId: ID!
  $filter: ModelAgendaUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  usersByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      tuesday
      type
      hours
      timezone
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const shiftsByComId = gql/* GraphQL */ `query ShiftsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    nextToken
    __typename
  }
}
`;